import { BlogResponse, MetaTagResponse } from '@/blog/domain/BlogResponse';
import { Category } from '@/blog/domain/Category';
import { Post } from '@/blog/domain/Post';

export class BlogPage {

  public posts: Array<Post>;
  public totalPosts: number;
  public categories: Array<Category>;
  public headTitle?: string;
  public metaTags?: Array<MetaTagResponse>;

  public constructor (blogResponse: BlogResponse) {
    this.posts = blogResponse.posts.map(post => new Post(post));
    this.totalPosts = blogResponse.totalPosts;
    this.headTitle = blogResponse.headTitle;
    this.metaTags = blogResponse.metaTags;
    this.categories = blogResponse.filters.categories.map(category => new Category({ name: category.value, slug: category.key }));
  }

}
